<template>
  <v-container class="success-container d-flex flex-column align-center justify-center container">
    <p class="text-body-1 text-center mt-0 mb-8" v-html="$t('rtwp.success.text', { id: id })" />
    <v-btn color="blue darken-1 white--text" @click="onNew">
      {{ $t("rtwp.success.button") }}
    </v-btn>
    <v-btn v-if="auth" @click="logout" class="mt-5">
      {{ $t("rtwp.success.logout") }}
      <v-icon right>fa-sign-out-alt</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import Vue from "vue";
import { Auth } from "@isocial-vue/blueprint";

export default Vue.extend({
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    auth: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    logout() {
      const logout = new Event("onLogout");
      document.dispatchEvent(logout);
    },
    onNew() {
      const reload = false;

      if (this.auth) {
        const claims = Auth.claims;

        if (!claims) {
          // reload = true;
          this.$router.push("/");
          return;
        } else {
          const date = new Date();
          const currentTime = date.getTime();
          // reload = !claims.exp || currentTime >= claims.exp * 1000;
          if (!claims.exp || currentTime >= claims.exp * 1000) {
            this.$router.push("/");
            return;
          }
        }
      }

      this.$emit("onNew", reload);
    },
  },
});
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
}

.text-body-1 {
  max-width: 550px;

  strong {
    white-space: nowrap;
  }
}
</style>
<style lang="scss">
.success-container {
  .text-body-1 {
    strong {
      white-space: nowrap;
    }
  }
}
</style>
